module.exports = __webpack_public_path__ + "img/YaoPin3.65b962be.png";